import Update from "../../table/Update";
import ApiService from "../../../services/apiService";
import {toast} from "react-toastify";
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom"
const UpdateProject = ()=>{
    const {id} = useParams();
    const navigate = useNavigate();
    const [data,setData] = useState<any>([])
    const initialData = {
         ProjectName:data?.projectName,
         No_Of_Door:data?.no_Of_Door,
         No_Of_WaterMeter:data?.no_Of_Door,
         No_Of_PressureValve:data?.no_Of_PressureValve,
         TotalValves: data?.totalValves
    }
    useEffect(() => {
        const fetchProject = async () => {
           try{
             const response = await ApiService.axiosApi(`/projectsettings/getprojectbyid${id}`,{
                method: 'GET',
             });
             if(response.success){
             
              setData(response.data)
                
             }
           }catch(error: any){
            toast.error(error.message);
           }
        }
         fetchProject();
      }, []);

      const onSubmit = async (data :any) => {
        try{
         console.log(data)
          const response = await ApiService.axiosApi(`/projectsettings/updateproject${id}`,{
            method: 'PUT',
            data: data,
          })
          if(response.success){
            toast.success("project updated successfully");
            navigate(-1);
          }else{
            toast.error(response.message);
          }
            
        }catch(error: any){
          toast.error(error.message);
        }
      }

    return(
       <>
         <Update
           title={"Update Project"}
           parentTitle = {"[roject"}

           fields={
             [
              {
                name : "ProjectName",
                label  :"Project Name",
                type: "text",
                validation :  { required: "Project Name is required" }
               },
               {
                name: "No_Of_Door",
                label: "Number Of Doors", 
                type: "text",
                validation : {required : "Value is required"}
               },
               {
                name: "No_Of_WaterMeter",
                label: "Number Of WaterMeters", 
                type: "text",
                validation : {required : "WaterMeters is required"}
               },
               {
                name: "No_Of_PressureValve",
                label: "Number Of PressureValve", 
                type: "text",
                validation : {required : "Pressure is required"}
               },
               {
                name: "TotalValves",
                label: "Number Of TotalValves", 
                type: "text",
                validation : {required : "TotalValve is required"}
               }
             ]
           }
           onSubmit={onSubmit}
           initialData={initialData}
           />
      </>
    )
}
export default UpdateProject